import HitApi from '@/services/Api/HitApi'

export default {
  namespaced: true,

  state: {
    hits: {
      data: []
    },
    edited_hit: null
  },

  mutations: {
    reset(state) {
      state.hits = {
        data: []
      }
    },

    addNew(state, hit) {
      state.hits.data.unshift(hit)
    },

    addMore(state, hits) {
      hits.data = state.hits.data.concat(hits.data)
      state.hits = hits
    },

    remove(state, hit) {
      state.hits.data = state.hits.data.filter(one_hit => one_hit.id !== hit.id)
    },

    setEdited(state, edited_hit) {
      state.edited_hit = edited_hit
    }
  },

  actions: {
    getList(context, config) {
      return HitApi.getList(config)
        .then(hits => context.commit('addMore', hits))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Hits.js